import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HardwareService } from '../../hardware.service';
import { HardwareSelectorBaseComponent } from '../hardware-selector-base.component';
import { SettingService } from 'app/shared/setting.service';
import { ProductNotesService } from '../../notes/product-notes.service';
import { AddToCartService } from '../../add-to-cart.service';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-hardware-selector',
  templateUrl: './hardware-selector.component.html',
  styleUrls: ['./hardware-selector.component.css']
})

export class HardwareSelectorComponent extends HardwareSelectorBaseComponent implements OnInit {
  constructor(private hardwareService: HardwareService,
    injector: Injector,
    route: ActivatedRoute,
    settingService: SettingService,
    productNotesService: ProductNotesService,
    addToCartService: AddToCartService,
    modalConfig: NgbModalConfig,
    modalService: NgbModal) {
    super(injector, route, settingService, productNotesService, addToCartService, modalService, modalConfig);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}

//export interface CardChangedEventArgs {
//  longSKU: string;
//  accessoryType: number;
//  category: string;
//  selected: boolean;
//}
